import "whatwg-fetch";
const env = process.env;

const getGrowplanInitial = data => {
  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/ag_lifecycles/getLifecycleStartInfo?access_token=${data.apitoken}&growplan_id=${data.growplan_id}&env=${env.VUE_APP_env}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
};

const getPlatformGroups = data => {
  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/infrastructure/getPlatformGroups?access_token=${data.apitoken}&area_id=${data.area_id}&env=${env.VUE_APP_env}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
};

const getLifeyclesByStrain = data => {
  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/ag_lifecycles/getLifecyclesByStrain?strain_id=${data.strain_id}&access_token=${data.apitoken}&env=${env.VUE_APP_env}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
};

export default {
  getGrowplanInitial,
  getPlatformGroups,
  getLifeyclesByStrain
};
